import { createSelector } from 'reselect'
import getRouteAndMatchRouterSelect from 'modules/router/selectors/get-route-and-match/index.js'
import isArticleRouterSelectUtil from 'modules/router/selectors/is-article/utils/index.js'

const isArticleRouterSelect = createSelector(
  getRouteAndMatchRouterSelect,
  (routeAndMatch) => isArticleRouterSelectUtil({
    routeAndMatch
  })
)

export default isArticleRouterSelect
